import Flickity from 'flickity-imagesloaded';

export default(() => {
    const carousels = Array.from(document.querySelectorAll('.sponsoring-members__carousel'));

    if (carousels) {
        carousels.forEach((carousel) => {
            new Flickity(carousel, {
                prevNextButtons: false,
                pageDots: true,
                lazyLoad: true,
                imagesLoaded: true,
                groupCells: true,
                cellAlign: 'left',
                autoPlay: 4000,
            });
        });
    }
})();
